const contractor = {
  wizardTitle: "Contractor Registration",
  wizardSubtitle: "Submit a registration application to the contractor registry",
  stepBusiness: "Business Details",
  stepLicense: "License & Classification",
  stepDocuments: "Documents",
  stepServiceArea: "Service Area",
  stepReview: "Review & Submit",
  businessName: "Business Name",
  businessId: "Business ID",
  phone: "Phone",
  email: "Email",
  address: "Address",
  licenseNumber: "Contractor License Number",
  classificationTier: "Classification Tier",
  classificationCategory: "Classification Categories",
  insuranceCert: "Insurance Certificate",
  licenseScan: "License Scan",
  documentsDesc: "Upload supporting documents (optional — can be added later)",
  licenseExpiry: "License Expiry Date",
  insuranceExpiry: "Insurance Expiry Date",
  serviceAreas: "Service Areas",
  back: "Back",
  next: "Next",
  submit: "Submit Application",
  submissionSuccess: "Application submitted successfully!",
  submissionSuccessDesc: "Our team will review your application and get back to you shortly.",
  confirmationNumber: "Confirmation Number",
} as const;
export default contractor;
